import type { FaireProductEntity } from "../../entity_types/product";

export const p_bdxjz48pcf: FaireProductEntity = {
  token: "p_bdxjz48pcf",
  type: "product",
  name: "Marquise Loose Lab Grown Diamond Stone VVS1 IGI Certified",
  brandToken: "b_6nzzuc6eex",
  brandName: "Fine Diamond",
  imageUrl:
    "https://cdn.faire.com/fastly/750a849580052fe541eb250493f87070628b06bb2359bdc0b7d671e258d1b085.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f5a6423ef24d6666f265718d97cae7a0f830202d757efb164762832898c4c524.jpeg",
    "https://cdn.faire.com/fastly/dc23af52da27bbe28a7e756152a0f91f343b2edb3a70ee4d08d557a61d65c550.jpeg",
    "https://cdn.faire.com/fastly/e77c178c0c8a9a1ac2fe8ba4e35186d1cdccf638e9d7f0b9f2c40aac36285054.jpeg",
    "https://cdn.faire.com/fastly/40445a9fd6cb4f7889fc4471e7b3e85371e9c7ec3fdf9d71ee9a257496122266.jpeg",
    "https://cdn.faire.com/fastly/472f13dd7de6018acfb521b451a25049d1ceba9a17c2d4f7f89409b5e88e8810.jpeg",
  ],
  priceDollars: 763.51,
  description:
    "This IGI-certified loose lab-grown diamond from Fine Diamond comes in a Marquise shape. It is available in D, E, and F color grades and has a VVS1 clarity rating. The diamond is offered in sizes ranging from 1 to 5 carats. \n\n\nProduct Type Color Carat Options Clarity \nLoose Lab-Grown Diamond D, E, F 1 to 5 Carats VVS1 \n\n\nAs a conflict-free and eco-conscious gemstone, this lab-created diamond is the perfect choice for those who care about sustainability without compromising on beauty. Ethically grown and responsibly sourced, it reflects modern values while maintaining all the natural allure of a traditional mined diamond. Ideal for crafting solitaire rings, pendants, and earrings, this gem offers complete design freedom with a clear conscience.\n\nWhether you're celebrating a special occasion, shopping for April birthstone gifts, or simply designing a timeless piece of jewelry, this premium lab-grown diamond represents strength, purity, and enduring elegance. Explore our complete collection of lab-made diamonds, loose gemstones, and custom jewelry stones to create meaningful pieces that reflect your values. At Fine Diamond, we’re committed to delivering excellence with every stone.\n",
  tags: [],
  msrpDollars: 3817.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:24.231Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
